export default __webpack_public_path__ + "static/media/askbtn.a2530702.svg";